import {
  StyledInnerDot,
  StyledPulsingBadgeContainer,
  StyledPulsingRing
} from './PulsingBadge.styles';
import { BadgeColors } from './PulsingBadge.types';

export const PulsingBadge = ({
  color,
  content
}: {
  color: BadgeColors;
  content: number | '';
}) => {
  const showBullet = content === '';

  return (
    <StyledPulsingBadgeContainer showBullet={showBullet}>
      <StyledInnerDot showBullet={showBullet} color={color}>
        {content}
      </StyledInnerDot>
      <StyledPulsingRing showBullet={showBullet} color={color} />
    </StyledPulsingBadgeContainer>
  );
};
